<template>
  <path
    d="M20.0001 6.8303V19.0003C20.0001 19.5503 19.5501 20.0003 19.0001 20.0003H6.83005L20.0001 6.8303ZM20.2901 3.7103L3.71005 20.2903C3.08005 20.9203 3.52005 22.0003 4.41005 22.0003H20.0001C21.1001 22.0003 22.0001 21.1003 22.0001 20.0003V4.4103C22.0001 3.5203 20.9201 3.0803 20.2901 3.7103Z"
  />
</template>
